export function tableSummary() {
  document.addEventListener("DOMContentLoaded", function () {
    const toggles = document.querySelectorAll(".summary-toggle");
    const summaries = document.querySelectorAll(".summary");
    const toggleAllButton = document.getElementById("toggleAll");

    if (toggleAllButton) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", function () {
          const summary = this.nextElementSibling;

          if (summary.classList.contains("max-h-0")) {
            summary.classList.remove("max-h-0");
            summary.classList.add("max-h-screen");
          } else {
            summary.classList.add("max-h-0");
            summary.classList.remove("max-h-screen");
          }
        });
      });

      // Toggle All button functionality
      toggleAllButton.addEventListener("click", function () {
        const isExpanded = toggleAllButton.textContent.includes("Expand");

        summaries.forEach((summary) => {
          if (isExpanded) {
            summary.classList.remove("max-h-0");
            summary.classList.add("max-h-screen");
          } else {
            summary.classList.add("max-h-0");
            summary.classList.remove("max-h-screen");
          }
        });

        toggleAllButton.textContent = isExpanded
          ? "Collapse All"
          : "Expand All";
      });
    }
  });
}
